var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.7,
    height: 22.7,
    viewBox: "0 0 22.7 22.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Left_arrow",
    "data-name": "Left arrow",
    d: "M871.324-2332.624A11.28,11.28,0,0,1,868-2340.65a11.278,11.278,0,0,1,3.324-8.025A11.276,11.276,0,0,1,879.35-2352a11.276,11.276,0,0,1,8.025,3.325,11.275,11.275,0,0,1,3.325,8.025,11.277,11.277,0,0,1-3.325,8.026,11.275,11.275,0,0,1-8.025,3.323A11.275,11.275,0,0,1,871.324-2332.624Zm-1.624-8.026a9.661,9.661,0,0,0,9.65,9.65,9.661,9.661,0,0,0,9.65-9.65,9.661,9.661,0,0,0-9.65-9.65A9.661,9.661,0,0,0,869.7-2340.65Zm8.465,4.469-3.478-3.478-.023-.022a.847.847,0,0,1-.248-.6.847.847,0,0,1,.273-.624l3.476-3.476a.849.849,0,0,1,1.2,0,.849.849,0,0,1,0,1.2l-2.049,2.049h6.115a.85.85,0,0,1,.85.85.85.85,0,0,1-.85.851h-6.115l2.049,2.049a.849.849,0,0,1,0,1.2.847.847,0,0,1-.6.249A.845.845,0,0,1,878.166-2336.181Z",
    transform: "translate(-868.001 2352)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowCircle);
export default __webpack_public_path__ + "static/media/LeftArrowCircle.0341a82eeee7cb13151cc48634bbed2f.svg";
export { ForwardRef as ReactComponent };